<template>
  <vs-text :type="textType">Created by {{ creatorName }} on {{ formattedCreatedTime }}</vs-text>
</template>

<script setup lang="ts">
import moment from 'moment'
import User from '../../models/user'
import { useStore } from 'vuex-composition-helpers'
import { computed } from 'vue'
import { getInstance } from '@/auth/auth.js'
import { User as UserAuth0 } from '@auth0/auth0-spa-js'

const props = withDefaults(
  defineProps<{
    creatorSid: string
    // Vue 2 limitation: Cannot use external type in defineProps
    // In this case, createdTime should be moment.Moment | string,
    // but Vue does not allow moment.Moment to be in the defineProps()
    createdTime?: object | string
    textType?: string
  }>(),
  {
    textType: 'paragraph',
    createdTime: undefined,
  },
)
const store = useStore()
const auth: { user: UserAuth0 } = getInstance()
const getUserBySid = computed<(id: string) => User>(() => store.getters['users/getBySid'])
const creatorName = computed(() => {
  const creator = getUserBySid.value(props.creatorSid)
  if (!creator && props.creatorSid === auth.user.sub) {
    // In the case of Global Admin, the 'creator' object is null, so we fallback to Auth0's name
    return auth.user.nickname
  }
  return creator ? creator.name : 'Unknown User'
})
const formattedCreatedTime = computed(() =>
  props.createdTime ? moment.utc(props.createdTime).local().format('MMM DD, YYYY HH:mm') : '',
)
</script>
